var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBharatSatStudentBackIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 91,
    viewBox: "0 0 149 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.959 -8.86007C139.452 -8.80881 141.994 -2.01561 137.884 1.6289L75.1091 57.2941C72.843 59.3036 69.4345 59.309 67.1619 57.3068L2.63194 0.453583C-1.53819 -3.22045 1.09683 -10.1 6.65433 -10.0481L133.959 -8.86007Z",
    fill: "#F6821F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.333 86.5895L103.29 31.6227L155.172 -16.2906L149.333 86.5895Z",
    fill: "#003891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBharatSatStudentBackIllustration);
export default __webpack_public_path__ + "static/media/bharatSATStudentBackIllustration.048b2f80f3ba7c4d265a879f4c4ed962.svg";
export { ForwardRef as ReactComponent };